import { isDev } from "@/helpers"

export interface AuthConfig {
    baseUrl: string;
    loginRedirect: string;
    loginRoute: string;
    platform?: "desktop" | "mobile";
    profileEndpoint: string;
    providers: {
      [provider: string]: {
        authorizationEndpoint: string;
        popupSize?: {
          height: number;
          width: number;
        }
      };
    }
    storage: "cookie" | "localStorage" | "sessionStorage";
    tokenName: string;
  }

const baseUrl = isDev() ? "http://localhost:3004/" : "https://promtcraft.herokuapp.com/"
const configForDevelopment = {
    baseUrl: baseUrl, // "http://localhost:3004/auth",
    loginRedirect: "profile",
    loginRoute: "login",
    platform: "desktop",
    storage: "localStorage",
    tokenName: "token",
    profileEndpoint: baseUrl + "/auth/me",
    providers: {
        facebook: {
            authorizationEndpoint: baseUrl + "auth/facebook",
            popupSize: { width: 580, height: 400 }
        },
        github: {
            authorizationEndpoint: baseUrl + "auth/github",
            popupSize: { width: 1020, height: 618 }
        },
        google: {
            authorizationEndpoint: baseUrl + "auth/google",
            popupSize: { width: 452, height: 633 }
        },
        linkedin: {
            authorizationEndpoint: baseUrl + "auth/linkedin",
            popupSize: { width: 527, height: 582 }
        },
        twitter: {
            authorizationEndpoint: baseUrl + "auth/twitter",
            popupSize: { width: 495, height: 645 }
        },
        microsoft: {
            authorizationEndpoint: baseUrl + "auth/microsoft",
            popupSize: { width: 500, height: 560 }
        },
        windowslive: {
            authorizationEndpoint: baseUrl + "auth/windowslive",
            popupSize: { width: 500, height: 560 }
        },
    }
} as AuthConfig

const configForProduction = {
    loginRedirect: "profile",
    providers: {
        facebook: {
            authorizationEndpoint: "http://example.com/auth/facebook",
        },
    }
} as Partial<AuthConfig>

let config: AuthConfig
if (window.location.hostname === "localhost") {
    config = configForDevelopment
} else {
    config = { ...configForProduction, ...configForDevelopment }
}

export default config
